import React from "react";
import { observer } from "mobx-react";
import { LlmProviderViewStore } from "../../store";
import { LlmProviderViewForm } from "./LlmProviderViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type LlmProviderViewProps = {
  llmProviderViewStore: LlmProviderViewStore;
};

export const LlmProviderView: React.FC<LlmProviderViewProps> = observer(
  ({ llmProviderViewStore }) => {
    return (
      <div>
        <LlmProviderViewForm
          name={llmProviderViewStore.nameValue}
          code={llmProviderViewStore.codeValue}
          requiresApiKey={llmProviderViewStore.requiresApiKeyValue}
          requiresBaseUrl={llmProviderViewStore.requiresBaseUrlValue}
          defaultModels={llmProviderViewStore.defaultModelsValue}
          logoUrl={llmProviderViewStore.logoUrlValue}
          onPrint={(handlePrint: () => void) =>
            llmProviderViewStore.printLlmProvider(handlePrint)
          }
          onCancel={() => llmProviderViewStore.cancelLlmProvider()}
          onEdit={
            llmProviderViewStore.isEditEnabled
              ? () => llmProviderViewStore.editLlmProvider()
              : undefined
          }
        />
        <ErrorDialog
          open={llmProviderViewStore.errorDialogOpened}
          title={llmProviderViewStore.errorTitle}
          description={llmProviderViewStore.errorDescription}
          onClose={() => llmProviderViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
